import React, { Component } from "react";
import "./style.css";
import song from "./cancion.mp3";

class PlayMusic extends Component {
  state = {
    audio: new Audio(song),
    isPlaying: false,
  };

  componentDidMount() {
    this.state.audio.play().then(() => {
      this.setState({ isPlaying: true });
    }).catch(() => {});
  }

  componentWillUnmount() {
    this.state.audio.pause();
  }

  playPause = () => {
    const { isPlaying, audio } = this.state;
    isPlaying ? audio.pause() : audio.play();
    this.setState({ isPlaying: !isPlaying });
  };

  render() {
    const { isPlaying } = this.state;
    return (
      <button
        className={`floating-btn song-btn ${isPlaying ? "song-btn--playing" : ""}`}
        onClick={this.playPause}
        title={isPlaying ? "Pausar música" : "Reproducir música"}
      >
        {isPlaying ? (
          <span className="song-pause" />
        ) : (
          <span className="song-play">♪</span>
        )}
      </button>
    );
  }
}

export default PlayMusic;
